import { memoSanitize } from '@axa-asia/emma-safely-set-inner-html';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import { t } from '../../../../locales';
import { hideModal } from '../../../../actions/uiActions';
import { getMyPrivilegesCardModal } from '../../selectors/myPrivilegesSelector';
import {
  triggerPopupDisplayScreenChange,
  triggerPopupCloseScreenChange,
} from '@axa-asia/hk-emma-web-module/lib/ga-lib/GaPreviousScreenUtil';

// import default image
import illusHealthChallenges from '../../../../assets/images/illusHealthChallenges.png';
import { resolveLocalizedText, resolvePublicAssets } from '../../../../utils';

//import Action
import { toggleModelDisplay } from '../../actions/myPrivilegesAction';

import './styles.scss';
import { getHaveTncDisclaimerState } from '../../../../selectors/tncDisclaimersSelectors';

interface MyPrivilegesModalViewProps {
  dropdownSection: any;
  serviceSection: any;
  haveTncDisclaimer?: boolean;
  isShowVhisModal?: boolean;
  toggleVhisModal: (toggle: boolean) => void;
  hideModal: () => void;
  icon?: any;
  title?: string;
  subtitle?: string;
  banner?: string;
  mobileBanner?: string;
  desc?: string;
  checkList?: Array<{
    text: string;
    hasRemark: boolean;
  }>;
  caption?: string;
  remarks?: Array<string>;
  btnText?: string;
  deepLink?: any;
  featureId?: string;
  selectedCardId?: string;
}

class MyPrivilegesModalView extends Component<MyPrivilegesModalViewProps> {
  constructor(props: any) {
    super(props);
    this.closeVhisModal = this.closeVhisModal.bind(this);
  }

  componentDidMount() {
    if (this.props.isShowVhisModal) {
      this.onModalShow();
    }
  }

  componentDidUpdate(prevProps: any) {
    if (
      prevProps.isShowVhisModal !== this.props.isShowVhisModal &&
      this.props.isShowVhisModal
    ) {
      this.onModalShow();
    }
  }

  onModalShow() {
    triggerPopupDisplayScreenChange(
      `${this.props.featureId}/${this.props.selectedCardId}`,
    );
  }

  closeVhisModal() {
    triggerPopupCloseScreenChange();
    this.props.toggleVhisModal(false);
    this.props.hideModal();
  }

  render() {
    const {
      isShowVhisModal,
      icon,
      title,
      subtitle,
      banner,
      mobileBanner,
      desc,
      checkList,
      caption,
      remarks,
      btnText,
      deepLink,
    } = this.props;
    return (
      <div>
        {isShowVhisModal && (
          <div className="myprivileges-modal">
            <div className="myprivileges-modal__overlay">
              <div className="myprivileges-modal__content">
                <div className="myprivileges-modal__content-header">
                  <button
                    className="myprivileges-modal__content-header-close"
                    onClick={() => this.closeVhisModal()}
                    data-enable-ga
                    data-ga-type="button"
                  >
                    {t('CLOSE')}
                  </button>
                </div>
                <div className="myprivileges-modal__content-container">
                  {icon && (
                    <img
                      className="myprivileges-modal__content-container__img"
                      src={icon}
                      alt=""
                    />
                  )}
                  {title && (
                    <p className="myprivileges-modal__content-container__txt__title">
                      {title}
                    </p>
                  )}
                  {subtitle && (
                    <p className="myprivileges-modal__content-container__txt__small">
                      {subtitle}
                    </p>
                  )}
                  {banner && (
                    <div
                      className="myprivileges-modal__content-container__banner-img"
                      style={{ backgroundImage: `url(${banner})` }}
                    ></div>
                  )}
                  {mobileBanner && (
                    <div
                      className="myprivileges-modal__content-container__banner-img-mobile"
                      style={{ backgroundImage: `url(${mobileBanner})` }}
                    ></div>
                  )}
                  {desc && (
                    <p
                      className="myprivileges-modal__content-container__txt"
                      dangerouslySetInnerHTML={{ __html: memoSanitize(desc) }}
                    ></p>
                  )}
                  {checkList && (
                    <div className="myprivileges-modal__content-container__checklist">
                      {checkList.map((checkListItem: any, index: number) => (
                        <div
                          key={index}
                          className="myprivileges-modal__content-container__checklist__item"
                        >
                          <img
                            className="myprivileges-modal__content-container__checklist__item__icon"
                            src={resolvePublicAssets(
                              '/assets/images/check-blue@3x.png',
                            )}
                            alt=""
                          />
                          <div className="myprivileges-modal__content-container__checklist__item__txt">
                            {checkListItem.hasRemark && (
                              <span className="myprivileges-modal__content-container__checklist__item__asterisk">
                                *
                              </span>
                            )}
                            {resolveLocalizedText(checkListItem.text)}
                          </div>
                        </div>
                      ))}
                    </div>
                  )}
                  {caption && (
                    <div className="myprivileges-modal__content-container__txt__caption">
                      {caption}
                    </div>
                  )}
                  {remarks && (
                    <div className="myprivileges-modal__content-container__remarks">
                      {remarks.map((remark: any, index: number) => (
                        <div
                          key={index}
                          className="myprivileges-modal__content-container__txt__remark"
                        >
                          {resolveLocalizedText(remark)}
                        </div>
                      ))}
                    </div>
                  )}
                </div>
                {btnText && (
                  <div className="myprivileges-modal__content-btn-wrapper">
                    {!deepLink && (
                      <button
                        className="myprivileges-modal__btn"
                        onClick={() => this.closeVhisModal()}
                        data-enable-ga
                        data-ga-type="button"
                      >
                        {btnText}
                      </button>
                    )}
                    {!!deepLink &&
                      !!deepLink.query &&
                      !!deepLink.query.contactNumber && (
                        <a
                          className="myprivileges-modal__btn myprivileges-modal__btn_a"
                          href={`tel: ${deepLink.query.contactNumber}`}
                          data-enable-ga
                          data-ga-type="link"
                        >
                          {btnText}
                        </a>
                      )}
                    {!!deepLink && !!deepLink.query && !!deepLink.query.url && (
                      <a
                        className="myprivileges-modal__btn myprivileges-modal__btn_a"
                        href={`${deepLink.query.url}`}
                        target="_blank"
                        rel="noopener noreferrer"
                        data-enable-ga
                        data-ga-type="link"
                      >
                        {btnText}
                      </a>
                    )}
                  </div>
                )}
              </div>
            </div>
          </div>
        )}
      </div>
    );
  }

  static mapStateToProps(state: any, ownProps: any) {
    const haveTncDisclaimerState = getHaveTncDisclaimerState(state);
    const { isShowVhisModal, selectedCardId } = getMyPrivilegesCardModal(state);
    const dropdownSectionOptionPopups =
      ownProps.dropdownSection && ownProps.dropdownSection.optionPopups;
    const serviceSectionPopups =
      ownProps.serviceSection && ownProps.serviceSection.popups;
    const popups = [
      ...(dropdownSectionOptionPopups || []),
      ...(serviceSectionPopups || []),
    ];

    const popupData =
      popups.find((item) =>
        [item.optionId, item.id].includes(selectedCardId),
      ) || {};
    return {
      selectedCardId,
      isShowVhisModal: isShowVhisModal && Object.keys(popupData).length > 0,
      icon: resolvePublicAssets(popupData.icon).replace('.png', '@3x.png'),
      title: popupData.title ? resolveLocalizedText(popupData.title) : '',
      subtitle: popupData.subtitle
        ? resolveLocalizedText(popupData.subtitle)
        : '',
      banner: resolvePublicAssets(popupData.banner).replace('.jpg', '@3x.jpg'),
      mobileBanner: resolvePublicAssets(popupData.mobileBanner).replace(
        '.jpg',
        '@3x.jpg',
      ),
      desc: popupData.desc ? resolveLocalizedText(popupData.desc) : '',
      btnText: popupData.btnText ? resolveLocalizedText(popupData.btnText) : '',
      deepLink: popupData.deepLink ? popupData.deepLink : undefined,
      checkList: popupData.checkList
        ? popupData.checkList.map(
            ({ hasRemark, text }: { hasRemark: boolean; text: any }) => ({
              hasRemark,
              text: text ? resolveLocalizedText(text) : '',
            }),
          )
        : undefined,
      caption: popupData.caption ? resolveLocalizedText(popupData.caption) : '',
      remarks: popupData.remarks
        ? popupData.remarks.map((remark: any) =>
            remark ? resolveLocalizedText(remark) : '',
          )
        : undefined,
    };
  }

  static mapDispatchToProps(dispatch: any) {
    return {
      toggleVhisModal: (toggle: boolean) =>
        dispatch(toggleModelDisplay(toggle)),
      hideModal: () => dispatch(hideModal()),
    };
  }
}

export default connect(
  MyPrivilegesModalView.mapStateToProps,
  MyPrivilegesModalView.mapDispatchToProps,
)(MyPrivilegesModalView);
